<template>
  <div class="flex flex-col h-full">
    <div class="flex-auto overflow-scroll">
      <h3 class="text-2xl font-bold pt-4 px-4">Configuración</h3>

      <div class="p-4">
        <div class="border border-gray-300 rounded bg-white p-4">
          <h4 class="text-lg font-bold">Recolección</h4>
          <p class="text-sm text-gray-500 mt-1">
            PickPack usará esta dirección cuando solicites una recolección.
          </p>

          <div class="mt-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">
              Dirección de recolección
            </label>

            <div
              v-if="loadingDirecciones"
              class="border border-gray-300 text-gray-500 rounded p-3"
            >
              Cargando direcciones…
            </div>

            <select
              v-else-if="direcciones.length > 0"
              v-model="direccionRecoleccion"
              class="border border-gray-300 focus:border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            >
              <option :value="null">Seleccionar una dirección</option>
              <option
                v-for="direccion in direcciones"
                :key="direccion.id"
                :value="direccion.id"
              >
                {{ direccion.nombre }} — {{ formatAddress(direccion) }}
              </option>
            </select>

            <div v-else class="border border-yellow-500 text-yellow-700 rounded p-3">
              No tienes direcciones guardadas.
            </div>

            <router-link
              v-if="!loadingDirecciones"
              :to="`/proveedor/${route.params.proveedor_id}/direccion`"
              class="inline-block underline text-primary mt-3"
            >
              Agregar dirección
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="p-4 flex-none border-t border-t-gray-300">
      <button
        :disabled="saving || !direccionRecoleccion"
        class="w-full bg-primary hover:bg-primary-dark disabled:opacity-50 rounded text-white font-bold py-2 px-4"
        @click="save"
      >
        Guardar configuración
      </button>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toast-notification";
import { utils } from "./utils/utils.js";
import { formatCollectionAddress } from "./utils/recolecciones.js";

export default {
  name: "ProveedorConfiguracion",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const proveedor = ref(null);
    const direcciones = ref([]);
    const direccionRecoleccion = ref(null);
    const saving = ref(false);
    const loadingDirecciones = ref(true);

    onMounted(async () => {
      try {
        const [providerData, addressData] = await Promise.all([
          utils.getProveedor(route.params.proveedor_id),
          utils.getDirecciones(route.params.proveedor_id),
        ]);

        if (providerData.standalone !== true) {
          return router.replace(`/proveedor/${route.params.proveedor_id}`);
        }

        proveedor.value = providerData;
        direcciones.value = addressData;
        direccionRecoleccion.value = providerData.direccion_recoleccion || null;
      } catch (error) {
        console.log(error);
        useToast().error("No se pudo cargar la configuración", {
          position: "top-right",
        });
      } finally {
        loadingDirecciones.value = false;
      }
    });

    async function save() {
      saving.value = true;
      try {
        await utils.updateProveedor(route.params.proveedor_id, {
          direccion_recoleccion: direccionRecoleccion.value,
        });
        useToast().success("Configuración guardada", {
          position: "top-right",
        });
      } catch (error) {
        console.log(error);
        useToast().error("No se pudo guardar la configuración", {
          position: "top-right",
        });
      } finally {
        saving.value = false;
      }
    }

    return {
      route,
      router,
      proveedor,
      direcciones,
      direccionRecoleccion,
      saving,
      loadingDirecciones,
      save,
      formatAddress: formatCollectionAddress,
    };
  },
};
</script>
